
import React from "react";

const ChecklistCTA: React.FC = () => {
  return (
    <div className="bg-gradient-to-r from-techne-deepPurple to-techne-purple rounded-xl shadow-lg p-8 text-white text-center">
      <h2 className="text-2xl font-bold mb-4">Need More Comprehensive AI Governance Support?</h2>
      <p className="text-lg mb-6 max-w-2xl mx-auto">
        Our team of experts can help your board establish a robust AI governance framework tailored to your organization's needs.
      </p>
      <div className="flex flex-wrap justify-center gap-4">
        <a 
          href="/contact" 
          className="border border-white hover:bg-white/10 text-white font-medium py-2.5 px-5 rounded-md transition-colors duration-300"
        >
          Contact Our Team
        </a>
      </div>
    </div>
  );
};

export default ChecklistCTA;
